(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shipping-cutoff-engine"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.yfpShippingCutoffInitialized) {
      window.yfpUpdateShippingCutoffs?.();
      return;
    }

    window.yfpShippingCutoffInitialized = true;

    const berlinFormatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    const translations = {
      active: 'Noch [time] — dann wird deine Bestellung heute verschickt',
      after: 'Heute bestellt — Versand am nächsten Werktag',
      weekend: 'Am Wochenende bestellt — Versand am nächsten Werktag'
    };

    const translationsElement = document.querySelector(
      '[data-shipping-cutoff-translations]'
    );

    if (translationsElement) {
      try {
        Object.assign(
          translations,
          JSON.parse(translationsElement.textContent)
        );
      } catch (error) {
        console.warn('Shipping cutoff translations could not be read.', error);
      }
    }

    const getBerlinTime = () =>
      Object.fromEntries(
        berlinFormatter
          .formatToParts(new Date())
          .map((part) => [part.type, part.value])
      );

    const formatDuration = (remainingSeconds) => {
      const locale = document.documentElement.lang || 'de-DE';
      const totalMinutes = Math.max(
        1,
        Math.ceil(remainingSeconds / 60)
      );
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      const parts = [];

      if (hours > 0) {
        parts.push(
          new Intl.NumberFormat(locale, {
            style: 'unit',
            unit: 'hour',
            unitDisplay: 'short'
          }).format(hours)
        );
      }

      parts.push(
        new Intl.NumberFormat(locale, {
          style: 'unit',
          unit: 'minute',
          unitDisplay: 'short'
        }).format(minutes)
      );

      return parts.join(' ');
    };

    const updateElement = (element, time) => {
      const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
      const isWeekday = weekdays.includes(time.weekday);

      const currentSeconds =
        Number(time.hour) * 3600 +
        Number(time.minute) * 60 +
        Number(time.second);

      const cutoffSeconds =
        Number(element.dataset.shippingCutoffHour || 14) * 3600 +
        Number(element.dataset.shippingCutoffMinute || 0) * 60;

      const remainingSeconds = cutoffSeconds - currentSeconds;
      const isActive = isWeekday && remainingSeconds > 0;
      const mode =
        element.dataset.shippingCutoffMode || 'message';

      const textElement = element.querySelector(
        '[data-shipping-cutoff-text]'
      );

    const setText = (text) => {
    if (textElement.textContent !== text) {
        textElement.textContent = text;
    }
    };

    const setActiveText = (template, duration) => {
    const token = '[time]';
    const tokenPosition = template.indexOf(token);

    if (tokenPosition === -1) {
        setText(template);
        return;
    }

    const completeText = template.replace(token, duration);

    if (textElement.textContent === completeText) {
        return;
    }

    const timeElement = document.createElement('strong');
    timeElement.className = 'shipping-cutoff__time';
    timeElement.textContent = duration;

    textElement.replaceChildren(
        document.createTextNode(template.slice(0, tokenPosition)),
        timeElement,
        document.createTextNode(
        template.slice(tokenPosition + token.length)
        )
    );
    };

      if (mode === 'progress' && !isActive) {
        element.hidden = true;
        return;
      }

      element.hidden = false;

      if (!isWeekday) {
        setText(
          element.dataset.shippingCutoffWeekend ||
          translations.weekend
        );
        return;
      }

      if (!isActive) {
        setText(
          element.dataset.shippingCutoffAfter ||
          translations.after
        );
        return;
      }

      const duration = formatDuration(remainingSeconds);

    setActiveText(
        element.dataset.shippingCutoffActive || translations.active,
        duration
        );

      if (mode === 'progress') {
        const progress = Math.max(
          0,
          Math.min(
            100,
            (remainingSeconds / cutoffSeconds) * 100
          )
        );

        const track = element.querySelector(
          '[data-shipping-cutoff-track]'
        );

        const fill = element.querySelector(
          '[data-shipping-cutoff-fill]'
        );

        track.setAttribute(
          'aria-valuenow',
          String(Math.round(progress))
        );

        fill.style.setProperty(
          '--shipping-cutoff-progress',
          String(progress / 100)
        );
      }
    };

    const updateAll = () => {
      const time = getBerlinTime();

      document
        .querySelectorAll('[data-shipping-cutoff]')
        .forEach((element) => {
          updateElement(element, time);
        });
    };

    window.yfpUpdateShippingCutoffs = updateAll;

    const start = () => {
      updateAll();

      window.setInterval(updateAll, 30000);

      new MutationObserver(updateAll).observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        start,
        { once: true }
      );
    } else {
      start();
    }

    document.addEventListener(
      'shopify:section:load',
      updateAll
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
